import { formatCurrency } from '@/utils/formatters';

/** Render a multiplier with at least one decimal (1 → "1.0") so badges stay
 *  visually consistent. Non-integer values keep whatever precision the user set. */
export function formatMultiplier(n: number): string {
  return Number.isInteger(n) ? n.toFixed(1) : n.toString();
}

export function buildCountModeRateLabel(
  premiumType: 'fixed' | 'percentage',
  premiumValue: number,
  premiumBasis: 'base_rate' | 'ot_inclusive',
  isStacked: boolean,
): string {
  let base: string;

  if (premiumType === 'fixed') {
    const formatted = `${formatCurrency(premiumValue, { showCents: !Number.isInteger(premiumValue) })}/hr`;
    base = premiumBasis === 'ot_inclusive' ? `${formatted} × overtime tier` : formatted;
  } else {
    const pct = `${Math.round(Number(premiumValue))}%`;
    base = premiumBasis === 'ot_inclusive' ? `${pct} × hourly rate × overtime tier` : `${pct} × hourly rate`;
  }

  return isStacked ? `${base} × missed breaks` : base;
}

export interface CanStackParams {
  requiredBreaks: number | null;
  requiredBreaksHalfDay: number | null;
  thresholdHours: number | null;
  thresholdFromBilling: number | null;
  additionalBreakIntervalHours: number | null;
}

export function canStackPremiums(params: CanStackParams): boolean {
  const { requiredBreaks, requiredBreaksHalfDay, thresholdHours, thresholdFromBilling, additionalBreakIntervalHours } = params;

  if ((requiredBreaks ?? 0) >= 2) return true;
  if ((requiredBreaksHalfDay ?? 0) >= 2) return true;

  const hasThreshold =
    (Number.isFinite(thresholdHours) && (thresholdHours as number) > 0) ||
    (Number.isFinite(thresholdFromBilling) && (thresholdFromBilling as number) > 0);
  const hasInterval =
    Number.isFinite(additionalBreakIntervalHours) && (additionalBreakIntervalHours as number) > 0;
  if (hasThreshold && hasInterval) return true;

  return false;
}
